<ui-assignee [uiAssignee]="currentCheckIn.assignee" [uiNameEllipsis]="true" uiSize="md"></ui-assignee>
<div class="labels" *ngIf="!currentCheckIn.isActive">
  <reflection-label-group [labels]="previousCheckIn?.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
  <div class="labels-separator"></div>
  <reflection-label-group [labels]="currentCheckIn.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
</div>
